import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import PrinterStatusIndicator from './PrinterStatusIndicator';
import logo from '../assets/logo.png';

const BarraNavegacion = ({ onToggleMobileMenu, isMobileMenuOpen }) => {
    const { user, logout } = useContext(AuthContext);
    const location = useLocation();
    const roleName = user?.role_details?.name;
    const isGestorCobranzas = roleName === 'GESTOR_COBRANZAS';

    const isCurrent = (path) => location.pathname === path;

    return (
        <header className="mobile-navbar" style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '64px',
            backgroundColor: '#ffffff',
            borderBottom: '1px solid var(--border-color, #e6d7cd)',
            padding: '0 1rem',
            position: 'sticky',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 999,
            boxShadow: '0 2px 8px rgba(74, 31, 12, 0.05)'
        }}>
            {/* Botón Menú Hamburguesa + Logo */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <button
                    type="button"
                    onClick={onToggleMobileMenu}
                    aria-label={isMobileMenuOpen ? 'Cerrar Menú' : 'Abrir Menú'}
                    style={{
                        width: '42px',
                        height: '42px',
                        borderRadius: '10px',
                        border: '1.5px solid var(--border-color, #e6d7cd)',
                        backgroundColor: isMobileMenuOpen ? 'var(--secondary-color, #d8c2b3)' : '#ffffff',
                        color: 'var(--primary-color, #4a1f0c)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                        flexShrink: 0
                    }}
                >
                    {isMobileMenuOpen ? (
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    ) : (
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="12" x2="21" y2="12"></line>
                            <line x1="3" y1="6" x2="21" y2="6"></line>
                            <line x1="3" y1="18" x2="21" y2="18"></line>
                        </svg>
                    )}
                </button>

                <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
                    <img
                        src={logo}
                        alt="Sophia's Coffee"
                        style={{ height: '36px', width: 'auto', objectFit: 'contain' }}
                    />
                    <div className="brand-title-wrap" style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{
                            fontSize: '1.05rem',
                            fontWeight: '800',
                            color: 'var(--primary-color, #4a1f0c)',
                            lineHeight: 1.1,
                            letterSpacing: '-0.3px'
                        }}>
                            Sophia's
                        </span>
                        <span style={{
                            fontSize: '0.65rem',
                            fontWeight: '600',
                            color: 'var(--accent-color, #c4823f)',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Coffee & POS
                        </span>
                    </div>
                </Link>
            </div>

            {/* Accesos Rápidos y Perfil */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {!isGestorCobranzas && (
                    <div className="navbar-quick-links" style={{ display: 'flex', gap: '0.4rem' }}>
                        <Link
                            to="/fast-food/pos"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.35rem',
                                padding: '0.45rem 0.75rem',
                                borderRadius: '8px',
                                backgroundColor: isCurrent('/fast-food/pos') ? 'var(--primary-color, #4a1f0c)' : 'var(--sidebar-bg, #f5ede4)',
                                color: isCurrent('/fast-food/pos') ? '#ffffff' : 'var(--primary-color, #4a1f0c)',
                                textDecoration: 'none',
                                fontWeight: '700',
                                fontSize: '0.8rem',
                                transition: 'all 0.2s',
                                border: '1px solid var(--border-color, #e6d7cd)'
                            }}
                        >
                            <i className="bi bi-cup-hot-fill"></i>
                            <span className="hide-on-mobile-xs">POS</span>
                        </Link>

                        <Link
                            to="/fast-food/shift"
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.35rem',
                                padding: '0.45rem 0.75rem',
                                borderRadius: '8px',
                                backgroundColor: isCurrent('/fast-food/shift') ? 'var(--primary-color, #4a1f0c)' : 'var(--sidebar-bg, #f5ede4)',
                                color: isCurrent('/fast-food/shift') ? '#ffffff' : 'var(--primary-color, #4a1f0c)',
                                textDecoration: 'none',
                                fontWeight: '700',
                                fontSize: '0.8rem',
                                transition: 'all 0.2s',
                                border: '1px solid var(--border-color, #e6d7cd)'
                            }}
                        >
                            <i className="bi bi-cash-coin"></i>
                            <span className="hide-on-mobile-xs">Caja</span>
                        </Link>
                    </div>
                )}

                {/* Avatar / Usuario */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.4rem',
                    padding: '0.3rem 0.6rem',
                    backgroundColor: 'var(--surface-hover, #f7f1eb)',
                    borderRadius: '20px',
                    border: '1px solid var(--border-color, #e6d7cd)'
                }}>
                    <div style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--primary-color, #4a1f0c)',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.8rem',
                        fontWeight: '700'
                    }}>
                        {user?.username?.charAt(0).toUpperCase() || 'U'}
                    </div>
                    <span className="hide-on-mobile-xs" style={{
                        fontSize: '0.8rem',
                        fontWeight: '600',
                        color: 'var(--text-primary, #2c1810)',
                        maxWidth: '85px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {user?.username || 'Usuario'}
                    </span>
                </div>
            </div>
        </header>
    );
};

export default BarraNavegacion;
